export const createFileChangeHandler = (formik, fileField, nameField = null) => {
  return (e) => {
    const file = e.target.files?.[0];

    if (file) {
      formik.setFieldValue(fileField, file);
      
      // If you want to store the name separately (recommended for clean display)
      if (nameField) {
        formik.setFieldValue(nameField, file.name);
      }
    } else {
      // Clear when user removes the file or cancels
      formik.setFieldValue(fileField, null);
      if (nameField) {
        formik.setFieldValue(nameField, '');
      }
    }
  };
};